export const SET_CHECKBOX_VALUE = 'checkoutPage/paymentCheckboxes/SET_CHECKBOX_VALUE';
export const SET_CHECKBOX_VALIDITY = 'checkoutPage/paymentCheckboxes/SET_CHECKBOX_VALIDITY';
export const RESET_PAYMENT_CHECKBOXES = 'checkoutPage/paymentCheckboxes/RESET_PAYMENT_CHECKBOXES';
